import { SxProps, Theme } from '@mui/material';

type TStyles = {
  text: SxProps<Theme>;
  button: SxProps<Theme>;
  container: SxProps<Theme>;
};

export const styles: TStyles = {
  text: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  }),

  button: () => ({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 3,
    gap: 3,
  }),
  container: () => ({
    width: {
      md: '550px',
      sm: '400px',
      xs: '80%',
    },
  }),
};
